import { icon } from './Icon';

/** Renders a panel <h3>, clickable when improvement recommendations exist. */
export function PanelTitle(
  iconName: string,
  title: string,
  topic: string,
  hasRecs: boolean,
  recHint: string,
): string {
  const attrs = hasRecs
    ? `class="panel-title clickable" data-rec="topic:${topic}" role="button" tabindex="0" title="${recHint}"`
    : 'class="panel-title"';
  const badge = hasRecs ? `<span class="rec-badge">${icon('lightbulb', 'icon icon-xs')}</span>` : '';
  return `<h3 ${attrs}>${icon(iconName)} <span>${title}</span>${badge}</h3>`;
}
